/*
 * Check if global object window is defined
 */
export const isBrowser = () => {
  return typeof window !== 'undefined'
}
